/* template */
<template><order-common-card :title="(title)" :sideTitle="(sideTitle)" :sideIcon="(sideIcon)" :sideColor="(sideColor)" @sideClick="onSideClick"><div v-for="(item, index) in (formatTips)" :key="item.index" class="tips"><div :class="({'tips-item':true, highlight:tip.highlight})" v-for="(tip, index) in (item)">{{tip.value}}</div></div></order-common-card></template>

/* styles */
<style scoped lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m7169e18e"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7169e18e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex7169e18e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex7169e18e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7169e18e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index7169e18e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'order-common-card':getComponent(require("../order-common-card/index.mpx?isComponent&outputPath=components%2Findexc3d6ce32%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
